import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=64ea53a4&scoped=true&lang=pug&"
import script from "./CardImage.vue?vue&type=script&lang=js&"
export * from "./CardImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea53a4",
  null
  
)

export default component.exports